var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13177_106462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3838 0.347656H7.58896C3.47723 0.347656 0.131836 3.55366 0.131836 7.49432V15.4794C0.131836 19.4198 3.47723 22.6258 7.58896 22.6258H16.3838C20.4958 22.6256 23.8412 19.4198 23.8412 15.4792V7.49432C23.8412 3.55366 20.4958 0.347656 16.3838 0.347656ZM21.6283 6.48448H18.0071L15.6167 2.36734H16.3838C18.9729 2.36734 21.1376 4.13962 21.6283 6.48448ZM10.6398 6.48448L8.24966 2.36734H13.2052L15.5954 6.48422L10.6398 6.48448ZM5.97646 2.60642L8.2278 6.48422H2.34471C2.72907 4.64833 4.13951 3.16436 5.97646 2.60642ZM16.3838 20.6059H7.58896C4.63925 20.6059 2.23934 18.3062 2.23934 15.4792V8.50417H21.7337V15.4794C21.7337 18.3062 19.3338 20.6059 16.3838 20.6059Z",
    fill: "url(#paint0_linear_13177_106462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3838 0.347656H7.58896C3.47723 0.347656 0.131836 3.55366 0.131836 7.49432V15.4794C0.131836 19.4198 3.47723 22.6258 7.58896 22.6258H16.3838C20.4958 22.6256 23.8412 19.4198 23.8412 15.4792V7.49432C23.8412 3.55366 20.4958 0.347656 16.3838 0.347656ZM21.6283 6.48448H18.0071L15.6167 2.36734H16.3838C18.9729 2.36734 21.1376 4.13962 21.6283 6.48448ZM10.6398 6.48448L8.24966 2.36734H13.2052L15.5954 6.48422L10.6398 6.48448ZM5.97646 2.60642L8.2278 6.48422H2.34471C2.72907 4.64833 4.13951 3.16436 5.97646 2.60642ZM16.3838 20.6059H7.58896C4.63925 20.6059 2.23934 18.3062 2.23934 15.4792V8.50417H21.7337V15.4794C21.7337 18.3062 19.3338 20.6059 16.3838 20.6059Z",
    fill: "url(#paint1_radial_13177_106462)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.981 13.2473L10.3946 10.8982C9.77127 10.5788 9.01758 11.0118 9.01758 11.6891V16.3877C9.01758 17.065 9.77127 17.498 10.3946 17.1786L14.981 14.8295C15.6407 14.4914 15.6407 13.5854 14.981 13.2473Z",
    fill: "url(#paint2_linear_13177_106462)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13177_106462",
    x1: 7.5,
    y1: 22.0412,
    x2: 7.5,
    y2: 0.47868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F1009A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5024FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_13177_106462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10 22.5203) rotate(-53.7491) scale(21.9846 22.7294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406814,
    stopColor: "#FF0035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B604EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13177_106462",
    x1: 6.50441,
    y1: 18.6436,
    x2: 19.417,
    y2: 4.49309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFD200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ED009B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7537FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13177_106462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.fd2b21500e27a1085016aed91d7285f0.svg";
export { ForwardRef as ReactComponent };